import React, { useState, useRef, useEffect } from 'react'
import { Stack, TextField, Button, Divider } from '@mui/material'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { useTranslation } from "react-i18next";
import { newTemplateActions } from "../../../../redux/slices/newTemplateSlice";
import { useDispatch, useSelector } from "react-redux";

function NtwXMLDataTemplate() {
  const { t } = useTranslation();
  const error = useRef();
  const fileBrowser = useRef();
  const [xmlFileVal, setXMLFileVal] = useState('');
  const [xmlData, setXMLData] = useState('')
  const dispatch = useDispatch();
  const newTemplate = useSelector(state => state.newTemplate)
  const handleUploadClick = (e) => {
    const file = e.target.files[0];
    setXMLFileVal(file.name)
    const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.')
    dispatch(newTemplateActions.setTemplateName(fileNameWithoutExtension))
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const fileInfo = e.target.result;
        dispatch(newTemplateActions.setXMLTemplateData({ fileInfo }));
      };
      reader.readAsText(file);
    }
  };
  const handleXMLPaste = (e) => {
    const val = e.target.value
    setXMLData(val);
    const hasFileInfo = newTemplate?.XMLTemplateData?.hasOwnProperty('fileInfo');
    if (!hasFileInfo) dispatch(newTemplateActions.setXMLTemplateData({ data: val }))

  }
  useEffect(() => {
    dispatch(newTemplateActions.setIsFormData(true))
  }, [])
  return (
    <>
      <Stack spacing={"8px"}>
        <div className='flex'>
          <TextField
            className='width-100'
            label={'Choose XML File'}
            variant="outlined"
            size='small'
            value={xmlFileVal}
            onChange={(e) => {
              error.current.textContent = ""
            }}
          >
          </TextField>
          <input
            style={{ display: "none" }}
            type="file"
            ref={fileBrowser}
            onChange={(e) => {
              // setXMLFileVal(e.target.value)
              error.current.textContent = "";
              handleUploadClick(e);
            }}
          />

          <Button
            variant="outlined"
            size="small"
            disableElevation
            className="margin-left-4"
            sx={{
              width: "40px",
              padding: "4px 8px",
              minWidth: "40px",
            }}
            onClick={() => {
              fileBrowser.current.click();
            }}>
            <DriveFolderUploadIcon fontSize="small" />
          </Button>
          <div>
            <p className="error" ref={error}></p>
          </div>
        </div>

        <Divider>{t('OR')}</Divider>
        <div style={{ width: '100%' }}>
          <TextField
            variant='outlined'
            className='width-100'
            size='medium'
            label={t('TXT_PASTE_XML_TEMPLATE_DATA_HERE')}
            rows={10}
            multiline
            value={xmlData}
            onChange={(e) => {
              handleXMLPaste(e)
            }}
          />
        </div>
      </Stack>
    </>
  )
}

export default NtwXMLDataTemplate